export default __webpack_public_path__ + "static/media/placeholder_immagine.f54ecf8d.png";